import { formatDate } from "lib/utils";
import Link from "next/link";
import { SubscriptionSubscriber } from "pages/admin/subscriptions/subscription/[id]";

interface Props {
  subscriptionObject: SubscriptionSubscriber;
}

export const SubscriptionDispatches = ({ subscriptionObject }: Props) => {
  return (
    <div className='col-span-full 2xl:col-span-2'>
      <span>Dispatches</span>
      <ul className='bg-gray-50 divide-y rounded'>
        {subscriptionObject.dispatches.map((dispatch, index) => (
          <Dispatch key={index} dispatch={dispatch} index={index} />
        ))}
      </ul>
    </div>
  );
};

interface DispatchProps {
  dispatch: SubscriptionSubscriber["dispatches"][number];
  index: number;
}

const Dispatch = ({ dispatch, index }: DispatchProps) => {
  return (
    <li
      className={`flex flex-row justify-between hover:bg-white hover:rounded border `}>
      <div className='py-4 pl-4'>{index + 1}</div>
      <div className='py-4'>
        {formatDate(new Date(dispatch.subscription_dispatch.created_at))}
      </div>
      <Link
        href={`/admin/subscriptions/dispatch-event/${dispatch.subscription_dispatch.id}`}>
        <a className='hover:underline py-4 pr-4'>View</a>
      </Link>
    </li>
  );
};
